import { render, staticRenderFns } from "./SignUpDocumentsUploader.vue?vue&type=template&id=2e374a07&scoped=true"
import script from "./SignUpDocumentsUploader.vue?vue&type=script&lang=js"
export * from "./SignUpDocumentsUploader.vue?vue&type=script&lang=js"
import style0 from "./SignUpDocumentsUploader.vue?vue&type=style&index=0&id=2e374a07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e374a07",
  null
  
)

export default component.exports